module.exports = __webpack_public_path__ + "img/learning-background.4d48593c.jpeg";